import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { EmployeeTabs } from '@/features/beneficiaries/employees/components/EmployeePage';
import { EmployeesPage } from '@/features/beneficiaries/employees/components/EmployeesPage';

const searchSchema = z.object({
  tab: z.enum(EmployeeTabs).optional(),
  columnFilters: z
    .array(
      z.object({
        id: z.string(),
        value: z.unknown(),
      })
    )
    .optional(),
});

export const Route = createFileRoute('/$commiteeSlug/beneficiaries/employees/{-$id}')({
  component: EmployeesPage,
  validateSearch: searchSchema,
});
